module.exports = __webpack_public_path__ + "img/github.cb365d78.jpg";